import { Text } from 'preact-i18n';
import SettingsLayout from '../SettingsLayout';
import SettingsSystemBatteryLevelWarning from './SettingsSystemBatteryLevelWarning';
import SettingsSystemContainers from './SettingsSystemContainers';
import SettingsSystemOperations from './SettingsSystemOperations';
import SettingsSystemTimezone from './SettingsSystemTimezone';
import SettingsSystemMdns from './SettingsSystemMdns';
import SettingsSystemKeepDeviceHistory from './SettingsSystemKeepDeviceHistory';
import SettingsSystemTimeExpiryState from './SettingsSystemTimeExpiryState';
import SettingsSystemDatabaseCleaning from './SettingsSystemDatabaseCleaning';
import SettingsSystemDuckDbMigration from './SettingsSystemDuckDbMigration';
import SettingsSystemDownloadLogs from './SettingsSystemDownloadLogs';

const SystemPage = ({ children, ...props }) => (
  <SettingsLayout>
    <div class="row">
      <div class="col-sm-6 col-lg d-flex">
        <div class="card p-3 flex-fill">
          <div class="d-flex flex-row align-items-center flex-sm-column">
            <span class="stamp stamp-md bg-blue mr-3 mr-sm-0 mb-sm-2">
              <i class="fe fe-activity" />
            </span>
            <div class="text-sm-center">
              <h4 class="m-0">
                <Text id="systemSettings.connected" />
              </h4>
              <small class="text-muted">
                <Text id="systemSettings.ping" fields={{ time: props.systemPing }} />
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg d-flex">
        <div class="card p-3 flex-fill">
          <div class="d-flex flex-row align-items-center flex-sm-column">
            <span class="stamp stamp-md bg-green mr-3 mr-sm-0 mb-sm-2">
              <i class="fe fe-hard-drive" />
            </span>
            <div class="text-sm-center">
              <h4 class="m-0">
                <Text id="systemSettings.disk" />
              </h4>
              <small class="text-muted">
                <Text
                  id="global.percentValue"
                  fields={{ value: props.systemDiskSpace && Math.ceil(props.systemDiskSpace.capacity * 100) }}
                />
              </small>
            </div>
          </div>
        </div>
      </div>

      {props.systemInfos && props.systemInfos.local_ip && (
        <div class="col-sm-6 col-lg d-flex">
          <div class="card p-3 flex-fill">
            <div class="d-flex flex-row align-items-center flex-sm-column">
              <span class="stamp stamp-md bg-azure mr-3 mr-sm-0 mb-sm-2">
                <i class="fe fe-globe" />
              </span>
              <div class="text-sm-center">
                <h4 class="m-0">
                  <Text id="systemSettings.localIp" />
                </h4>
                <small class="text-muted">{props.systemInfos.local_ip}</small>
              </div>
            </div>
          </div>
        </div>
      )}

      {props.systemInfos && props.systemInfos.cpu_temperature != null && (
        <div class="col-sm-6 col-lg d-flex">
          <div class="card p-3 flex-fill">
            <div class="d-flex flex-row align-items-center flex-sm-column">
              <span
                class={`stamp stamp-md mr-3 mr-sm-0 mb-sm-2 ${
                  props.systemInfos.cpu_temperature >= 75
                    ? 'bg-red'
                    : props.systemInfos.cpu_temperature >= 60
                    ? 'bg-orange'
                    : 'bg-green'
                }`}
              >
                <i class="fe fe-thermometer" />
              </span>
              <div class="text-sm-center">
                <h4 class="m-0">
                  <Text id="systemSettings.cpuTemperature" />
                </h4>
                <small class="text-muted">
                  <Text id="systemSettings.cpuTemperatureValue" fields={{ value: props.systemInfos.cpu_temperature }} />
                </small>
              </div>
            </div>
          </div>
        </div>
      )}

      <div class="col-sm-6 col-lg d-flex">
        <div class="card p-3 flex-fill">
          <div class="d-flex flex-row align-items-center flex-sm-column">
            <span class="stamp stamp-md bg-red mr-3 mr-sm-0 mb-sm-2">
              <i class="fe fe-heart" />
            </span>
            <div class="text-sm-center">
              <h4 class="m-0">
                <Text id="systemSettings.uptime" />
              </h4>
              <small class="text-muted">{props.systemInfos && props.systemInfos.uptime_formatted}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg d-flex">
        <div class="card p-3 flex-fill">
          <div class="d-flex flex-row align-items-center flex-sm-column">
            <span class="stamp stamp-md bg-yellow mr-3 mr-sm-0 mb-sm-2">
              <i class="fe fe-git-commit" />
            </span>
            <div class="text-sm-center">
              <h4 class="m-0">
                <Text id="systemSettings.gladysVersion" />
              </h4>
              <small class="text-muted">{props.systemInfos && props.systemInfos.gladys_version}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Thematic columns: system & maintenance on the left (updates,
        containers, logs, database upkeep), behavior preferences on the
        right — and the containers list gets a full column width instead
        of overflowing at the bottom of a crowded one. */}
    <div class="row">
      <div class="col-lg-6">
        <SettingsSystemOperations
          upgradeGladys={props.upgradeGladys}
          SystemUpgradeStatus={props.SystemUpgradeStatus}
          watchtowerLogs={props.watchtowerLogs}
          upgradeError={props.upgradeError}
          websocketConnected={props.websocketConnected}
          checkForUpdates={props.checkForUpdates}
          SystemGetInfosStatus={props.SystemGetInfosStatus}
          CheckForUpdatesStatus={props.CheckForUpdatesStatus}
          systemInfos={props.systemInfos}
        />
        <SettingsSystemContainers />
        <SettingsSystemDownloadLogs />
        <SettingsSystemDatabaseCleaning />
        <SettingsSystemDuckDbMigration />
      </div>
      <div class="col-lg-6">
        <SettingsSystemTimezone />
        <SettingsSystemMdns systemInfos={props.systemInfos} />
        <SettingsSystemBatteryLevelWarning />
        <SettingsSystemKeepDeviceHistory />
        <SettingsSystemTimeExpiryState />
      </div>
    </div>
  </SettingsLayout>
);

export default SystemPage;
